// Generated by scripts/sync-catalog-sitemap.mjs - do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const providersSlugMap = {
    "1x2gaming": "1X2gaming",
    "3oaks": "3oaks",
    "4theplayer": "4ThePlayer",
    "amusnet": "Amusnet",
    "avatarux": "AvatarUX",
    "aviator": "Aviator",
    "bang-bang-games": "Bang Bang Games",
    "bgaming": "BGaming",
    "bigpot-gaming": "Bigpot Gaming",
    "blueprint-gaming": "Blueprint Gaming",
    "egtdigital": "Egtdigital",
    "electric-elephant": "Electric Elephant",
    "endorphina": "Endorphina",
    "evoplay": "Evoplay",
    "expanse-studios": "Expanse Studios",
    "ezugi": "Ezugi",
    "fantasma": "Fantasma",
    "fbastards": "Fbastards",
    "four-leaf-gaming": "Four Leaf Gaming",
    "galaxsys": "Galaxsys",
    "gameart": "GameArt",
    "gametech": "GameTech",
    "gamingcorps": "GamingCorps",
    "hacksaw-gaming": "Hacksaw Gaming",
    "hot-rise-games": "Hot Rise Games",
    "irondog": "IronDog",
    "jili-games": "Jili Games",
    "libertyspins": "Libertyspins",
    "manna-play": "Manna Play",
    "max-win-gaming": "Max Win Gaming",
    "microgaming": "MicroGaming",
    "million-games": "Million Games",
    "novomatic": "Novomatic",
    "onetouch": "Onetouch",
    "penguinking": "Penguinking",
    "peter-and-sons": "Peter & Sons",
    "pgsoft": "PGSoft",
    "play-n-go": "Play n GO",
    "playson": "Playson",
    "playtech": "Playtech",
    "playtech-live": "Playtech Live",
    "playzia": "Playzia",
    "pragmatic-play": "Pragmatic Play",
    "pragmatic-play-live": "Pragmatic Play Live",
    "print-studios": "Print Studios",
    "prospectgaming": "ProspectGaming",
    "quickspin": "Quickspin",
    "reelplay": "ReelPlay",
    "reflex-gaming": "Reflex Gaming",
    "relax-gaming": "Relax Gaming",
    "rocketbet-originals": "RocketBet Originals",
    "shadylady": "Shadylady",
    "skywind": "Skywind",
    "skywind-live": "Skywind Live",
    "slotmill": "Slotmill",
    "solvited": "Solvited",
    "spinomenal": "Spinomenal",
    "storm-gaming": "Storm Gaming",
    "sweepnow": "Sweepnow",
    "tomhorn": "TomHorn",
    "topspin": "Topspin",
    "trigger": "Trigger",
    "twainsport": "TwainSport",
    "wazdan": "Wazdan",
    "winfast": "Winfast",
    "yggdrasil-gaming": "Yggdrasil Gaming",
};
